<template>
  <div class="credit_share">
    <img src="../../assets/imgs/credit_share/header.png" alt="" />
    <img src="../../assets/imgs/credit_share/1.png" alt="" />
    <img src="../../assets/imgs/credit_share/2.png" alt="" />
    <img src="../../assets/imgs/credit_share/3.png" alt="" />
    <img src="../../assets/imgs/credit_share/4.png" alt="" />
    <img src="../../assets/imgs/credit_share/5.png" alt="" />
    <img src="../../assets/imgs/credit_share/6.png" alt="" />
    <img style="margin-bottom: -10px;" src="../../assets/imgs/credit_share/7.png" alt="" />
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.credit_share{
  width: 100%;
  height: 100%;
  background-color: white;
  img{
    width: 100%;
    height: auto;
  }
}
</style>
